// clamp in [min,max]
function clamp(v, min, max) {
  return Math.min(Math.max(v, min), max);
}

document.addEventListener('click', event => {
  const modal = document.querySelector('q-modal[data-modal-active="true"]');
  const closeButton = document.querySelector('#close-modal');
  if (!modal || !closeButton) return;

  const clicked = event.target;
  const img = clicked.closest('.q-figure__image');
  const isButton = clicked.closest('button');
  const isCaptionClick = clicked.closest('.q-lightbox-slides__caption-content');
  const slide = clicked.closest('.q-lightbox-slides__slide');

  if (img && slide) {
    const wasZoomed = img.classList.contains('zoomed');
    const caps = modal.querySelectorAll('.q-lightbox-slides__caption');

    if (!wasZoomed) {
      // calcola frazioni sul thumbnail
      const r = img.getBoundingClientRect();
      const fx = (event.clientX - r.left)  / r.width;
      const fy = (event.clientY - r.top)   / r.height;

      // zoom
      img.classList.add('zoomed');
      // togli ogni max constraint
      img.style.maxWidth  = 'none';
      img.style.maxHeight = 'none';
      // nascondi didascalie
      caps.forEach(c=>c.style.display='none');
      slide.style.overflow = 'auto';

      requestAnimationFrame(()=>{
        const cw = slide.clientWidth,  ch = slide.clientHeight;
        const sw = slide.scrollWidth,  sh = slide.scrollHeight;

        const tx = clamp(fx * sw - cw/2, 0, sw - cw);
        const ty = clamp(fy * sh - ch/2, 0, sh - ch);

        slide.scrollTo({ left: tx, top: ty, behavior: 'smooth' });
      });
    } else {
      // zoom out
      img.classList.remove('zoomed');
      img.style.maxWidth = '';
      img.style.maxHeight= '';
      caps.forEach(c=>c.style.display='');
      slide.scrollTo({ left:0, top:0, behavior:'smooth' });
      slide.style.overflow = '';
    }
    return;
  }

  if (!isButton && !isCaptionClick && modal.contains(clicked)) {
    closeButton.click();
  }
});

// reset on modal-close
const modalEl = document.querySelector('q-modal');
if (modalEl) {
  new MutationObserver(ms => {
    ms.forEach(m => {
      if (m.type==='attributes' && m.attributeName==='data-modal-active'
          && modalEl.getAttribute('data-modal-active')!=='true') {
        document.querySelectorAll('.q-figure__image.zoomed').forEach(img=>{
          img.classList.remove('zoomed');
          img.style.maxWidth = '';
          img.style.maxHeight= '';
        });
        document.querySelectorAll('.q-lightbox-slides__slide').forEach(s=>{
          s.scrollTo({ left:0, top:0 });
          s.style.overflow = '';
        });
        document.querySelectorAll('.q-lightbox-slides__caption').forEach(c=>{
          c.style.display = '';
        });
      }
    });
  }).observe(modalEl, { attributes: true });
}
